import React from 'react';

import { ContentTemplate } from '../../types';
import { TemplatePreviewProps } from './types';

import {
  TemplatePreviewContainer,
  TemplatePreviewContainerInner,
  TemplatePreviewTitle,
  TemplatePreviewDescription,
  TemplatePreviewContent,
} from './TemplatePreview.styled';

import { AulaEditorWithoutTemplates } from '../../EditorInner';

export const TemplatePreview = ({
  selectedTemplateId,
  templates,
}: TemplatePreviewProps) => {
  const selectedTemplate = templates.find(
    (template: ContentTemplate) => template.id === selectedTemplateId,
  );

  return (
    <TemplatePreviewContainer>
      <TemplatePreviewContainerInner>
        <TemplatePreviewTitle data-testid="template-preview-title">
          {selectedTemplate?.name}
        </TemplatePreviewTitle>
        <TemplatePreviewDescription data-testid="template-preview-description">
          {selectedTemplate?.description}
        </TemplatePreviewDescription>
        <TemplatePreviewContent data-testid="template-preview-content">
          <AulaEditorWithoutTemplates
            key={selectedTemplateId}
            editorState={selectedTemplate?.content}
            readOnly
          />
        </TemplatePreviewContent>
      </TemplatePreviewContainerInner>
    </TemplatePreviewContainer>
  );
};
